module.exports = __webpack_public_path__ + "img/icon_placeholder.110ee57c.svg";